import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import Hint from 'components/Hint';
import PlaylistDropdown from 'components/ParentPlaylistDropdown';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ParentPlaylistsInfo = function ParentPlaylistsInfo(_ref) {
  var parentPlaylists = _ref.parentPlaylists,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'asset' : _ref$type;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var parentPlaylistCount = parentPlaylists.length;
  var key = type === 'playlist' ? 'parent_playlist_playlist_panel_hint_title' : 'parent_playlist_asset_panel_hint_title';
  return /*#__PURE__*/_jsx(Hint, {
    children: /*#__PURE__*/_jsxs(Trans, {
      t: t,
      i18nKey: key,
      count: parentPlaylistCount,
      children: ["This ".concat(type, " is in"), ' ', /*#__PURE__*/_jsx(PlaylistDropdown, {
        playlists: parentPlaylists,
        children: "count playlists"
      })]
    })
  });
};
export default ParentPlaylistsInfo;